<script lang="ts">
  import { toasts, dismissToast } from '$lib/util/toasts'
</script>

<!-- Per-toast live regions (on the message, so the Dismiss button isn't read
     out): errors use role="alert" (assertive, interrupts) so they're heard
     promptly; success/info use role="status" (polite). The container itself is
     not a live region or landmark. -->
<div class="toast-container">
  {#each $toasts as toast (toast.id)}
    <div class="toast toast-{toast.kind}">
      <span role={toast.kind === 'error' ? 'alert' : 'status'}>{toast.message}</span>
      <button type="button" onclick={() => dismissToast(toast.id)} aria-label="Dismiss">×</button>
    </div>
  {/each}
</div>

<style>
  .toast-container {
    position: fixed;
    top: 16px;
    right: 16px;
    z-index: 200;
    display: flex;
    flex-direction: column;
    gap: 8px;
    max-width: 400px;
  }
  .toast {
    padding: 12px 16px;
    border-radius: 6px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 12px;
  }
  .toast-error {
    background: var(--err-bg);
    color: var(--err-ink);
    border: 1px solid var(--err-line);
  }
  .toast-success {
    background: var(--ok-bg);
    color: var(--ok-ink);
    border: 1px solid var(--ok-line);
  }
  .toast-info {
    background: var(--brand-tint);
    color: var(--link);
    border: 1px solid var(--brand-tint);
  }
  button {
    background: none;
    border: none;
    cursor: pointer;
    font-size: 1.1rem;
    color: inherit;
    opacity: 0.7;
  }
  button:hover {
    opacity: 1;
  }
</style>
